import { BillingSettings } from "../../settings/settings.interface";

export function isFeatureBlocked(
  isSuperAdmin: boolean,
  billingSettings?: BillingSettings | null,
): boolean {
  if (isSuperAdmin) {
    return false;
  }

  if (!billingSettings) {
    return false;
  }

  const planName = billingSettings.planName?.toLowerCase();
  const planId = billingSettings.planId?.toLowerCase();

  return (
    planName === "basic" &&
    planId === "paid" &&
    billingSettings.billingMode === "upfront"
  );
}
